module.exports = __webpack_public_path__ + "static/btclassic-mac-screen@3x-ec9042bc08b9a48a173dc300d0d7984b.jpg";